export default "__VITE_ASSET__Cu531$FM__"